import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.913 10.016H1.374C3.342 4.205 8.74 0 15.174 0c8.084 0 14.652 6.588 14.652 14.757 0 1.178-.16 2.303-.426 3.374l-11.46-8.115zm-16.539 0 11.886 8.41v10.873C6.08 28.335.523 22.229.523 14.757c0-1.661.346-3.241.851-4.714z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }